import { render, staticRenderFns } from "./AutoUpdates.vue?vue&type=template&id=59668c98"
import script from "./AutoUpdates.vue?vue&type=script&lang=js"
export * from "./AutoUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports